interface BadgeProps {
  label: string;
  color: string;
  className?: string;
}

export function Badge({ label, color, className = '' }: BadgeProps) {
  return (
    <span
      className={`
        inline-block rounded-full px-3 py-1 text-[10px] font-mono font-medium tracking-wider uppercase
        ${className}
      `}
      style={{
        backgroundColor: `${color}12`,
        color: color,
        border: `1px solid ${color}25`,
      }}
    >
      {label}
    </span>
  );
}
